import React from 'react';

import ProtectedData from 'pages/item/v2/components/ProtectedData';

import useStyles from './styles';

interface Props {
    href: string;
    label: string;
}

const Link: React.FC<Props> = ({ href, label }) => {
    const { classes } = useStyles();

    return (
        <ProtectedData data={label}>
            <a className={classes.link} target="_blank" href={href} rel="nofollow">
                {label}
            </a>
        </ProtectedData>
    );
};

export default Link;
